<template>
    <el-card class="info-card" :body-style="{padding: '15px 50px',height: '100px',display: 'flex'}">
        <div class="img">
            <img src="@p/assets/images/user1.png" alt="">
        </div>
        <div class="info">
            <div class="info-name">
                <p>{{$store.state.home.userInfo.staff.username}}</p>
            </div>
            <div class="info-staff">
                <p class="department" v-html="'部門：'+this.$store.state.home.userInfo.staff.department_name"></p>
                <p class="position">職位：{{$store.state.home.userInfo.staff.position_name}}</p>
            </div>
        </div>
    </el-card>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
.info-card{
    width: 1200px;
    height: 130px;
}
.img{
    display: inline-block;
    width: 100px;
    height: 100px;
    margin-right: 50px;
    border-radius: 50%;
    background: #4D8EF6;
    color: #ffffff;
    border: 1px solid #4D8EF6;
    img{
        width: 100%;
    }
}
.info{
    display: inline-block;
    height: 100px;
    &-name{
        color: #333;
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
        margin-top: 10px;
    }
    &-staff{
        margin-top: 10px;
        font-size: 14px;
        line-height: 30px;
        color: rgba(51,51,51,0.70);
    }
}
</style>